// Check if global scope is available
window.RosenheimJetzt = window.RosenheimJetzt ? window.RosenheimJetzt : []

/**
 * Controls the behaviour of the scroll to top
 * @type {Window.RosenheimJetzt.ContrastMode}
 */
window.RosenheimJetzt.ContrastMode = class Example {
	constructor() {
		this.contrastModeIdentifier = 'contrast-mode'
		this.button = document.querySelector('.js-contrast-mode')
		// add event
		this.addToggleEvent()
		// initial state of contrast mode
		if (this.checkLocalStorage()) this.toggleCssClass()
	}

	addToggleEvent() {
		this.button.addEventListener('click', () => this.toggleContrastMode())
	}

	checkLocalStorage() {
		return localStorage.getItem(this.contrastModeIdentifier)
	}

	toggleContrastMode() {
		if (this.checkLocalStorage()) {
			localStorage.removeItem(this.contrastModeIdentifier)
		} else {
			localStorage.setItem(this.contrastModeIdentifier, this.contrastModeIdentifier)
		}
		this.toggleCssClass()
	}

	toggleCssClass() {
		document.documentElement.classList.toggle(this.contrastModeIdentifier)
	}
}
